import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useJumpNavigationCtx } from '@sweetgreen/garnish';

import { useNavigateToLastOrderMenu } from '@order/hooks';
import { useTelemetry } from '@order/Telemetry';

/**
 * Handler for the "Action Rails" action cards.
 *
 * explore_menu       | opens the last order's menu
 * upgrade_sweetpass  | takes you to upgrade screen
 * explore_benefits   | takes you to sweetpass benefits screen
 * explore_challenges | scrolls you down to challenges section
 * explore_rewards    | scrolls you down to rewards section
 *
 * @see {@link https://sweetgreen.atlassian.net/browse/CELS-646}
 */

export const Actions = {
  UpgradeSweetpass: 'upgrade_sweetpass',
  ExploreMenu: 'explore_menu',
  ExploreBenefits: 'explore_benefits',
  ExploreChallenges: 'explore_challenges',
  ExploreRewards: 'explore_rewards',
};

export const VALID_ACTIONS_FOR_SWEETPASS_ACTIONS_RAIL = new Set(
  Object.values(Actions),
);
export const useActionsRailHandler = () => {
  const { track } = useTelemetry();
  const navigation = useNavigation();
  const handleViewMenu = useNavigateToLastOrderMenu();
  const jumpContext = useJumpNavigationCtx();

  return useCallback(
    (action: string) => {
      track('sweetpass_home.action_card.tapped', { action });

      if (action === Actions.UpgradeSweetpass) {
        navigation.navigate('Modal', { screen: 'SweetpassUpgrade' });

        return;
      }

      if (action === Actions.ExploreMenu) {
        handleViewMenu();

        return;
      }

      if (action === Actions.ExploreBenefits) {
        navigation.navigate('Modal', { screen: 'SweetpassBenefits' });

        return;
      }

      if (action === Actions.ExploreChallenges) {
        jumpContext.setCurrentTarget('challenges-rail');

        return;
      }

      if (action === Actions.ExploreRewards) {
        jumpContext.setCurrentTarget('rewards-rail');
      }
    },
    [navigation, jumpContext, handleViewMenu, track],
  );
};
